import styled from 'styled-components';

import { spacing } from '../../../styles/theme';

const VideoWrapperStyles = styled.div`
  order: 2;
  width: 100%;
  margin-top: ${spacing('3')};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

export default VideoWrapperStyles;
